import { render, staticRenderFns } from "./Error_404.vue?vue&type=template&id=06a1d8f1&"
import script from "./Error_404.vue?vue&type=script&lang=js&"
export * from "./Error_404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports